import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { EngagementRituals } from './EngagementRituals';
import { UpsellLayers } from './UpsellLayers';
import { SegmentationHub } from './SegmentationHub';
import { OwnerControlLayer } from './OwnerControlLayer';
import { TokenEconomy } from './TokenEconomy';
import { ReEngagementTools } from './ReEngagementTools';
import { FallbackMonetization } from './FallbackMonetization';
import { AngelStudio } from './AngelStudio';
import { CrossVertical } from './CrossVertical';
import { OffersHome } from './offers/OffersHome';
import { Backoffers } from './offers/Backoffers';
import { SecondClickOffers } from './offers/SecondClickOffers';
import { Smartlinks } from './offers/Smartlinks';
import { X } from 'lucide-react';
interface MonetizationBoardProps {
  onClose: () => void;
}
export const MonetizationBoard: React.FC<MonetizationBoardProps> = ({
  onClose
}) => {
  const [activeSection, setActiveSection] = useState('segmentation-hub');
  return <div className="flex h-full w-full bg-gray-100 dark:bg-gray-900 overflow-hidden" data-id="element-11172">
      <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} data-id="element-11173" />
      <div className="flex-1 overflow-auto relative" data-id="element-11174">
        <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white dark:bg-gray-800 shadow-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" data-id="element-11175">
          <X size={20} className="text-gray-500 dark:text-gray-400" data-id="element-11176" />
        </button>
        <div className="p-6" data-id="element-11177">
          {activeSection === 'engagement-rituals' && <EngagementRituals data-id="element-11178" />}
          {activeSection === 'upsell-layers' && <UpsellLayers data-id="element-11179" />}
          {activeSection === 'segmentation-hub' && <SegmentationHub data-id="element-11180" />}
          {activeSection === 'owner-control' && <OwnerControlLayer data-id="element-11181" />}
          {activeSection === 'token-economy' && <TokenEconomy data-id="element-11182" />}
          {activeSection === 're-engagement' && <ReEngagementTools data-id="element-11183" />}
          {activeSection === 'fallback-monetization' && <FallbackMonetization data-id="element-11184" />}
          {activeSection === 'offers' || activeSection === 'offers-home' && <OffersHome data-id="element-11185" />}
          {activeSection === 'backoffers' && <Backoffers data-id="element-11186" />}
          {activeSection === 'second-click-offers' && <SecondClickOffers data-id="element-11187" />}
          {activeSection === 'smartlinks' && <Smartlinks data-id="element-11188" />}
          {activeSection === 'angel-studio' && <AngelStudio data-id="element-11189" />}
          {activeSection === 'cross-vertical' && <CrossVertical data-id="element-11190" />}
        </div>
      </div>
    </div>;
};